module.exports = __webpack_public_path__ + "img/3.fc3e45d7.jpg";